exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "ul li[data-v-4055ef1a]{font-size:13px}", ""]);

// exports
